import { useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router';
import { getRoutePrefix } from 'services/theming';
import useUser from 'hooks/useUser';
import { isHeadless } from 'utils/headless';

export const RequiresAuth = ({ allowHeadless = false }: { allowHeadless?: boolean }) => {
  const prefix = getRoutePrefix();

  const { user } = useUser();
  const navigate = useNavigate();
  const headless = isHeadless();

  useEffect(() => {
    if (user || (headless && allowHeadless)) {
      return;
    }
    navigate(`${prefix}/login`, { replace: true });
  }, [navigate, prefix, headless, user, allowHeadless]);

  if (user || (headless && allowHeadless)) {
    return <Outlet />;
  }

  return <Navigate to={`${prefix}/login`} replace />;
};
